/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RemixNotificationAction } from './RemixNotificationAction';
import {
    RemixNotificationActionFromJSON,
    RemixNotificationActionFromJSONTyped,
    RemixNotificationActionToJSON,
} from './RemixNotificationAction';

/**
 * 
 * @export
 * @interface RemixNotification
 */
export interface RemixNotification {
    /**
     * 
     * @type {string}
     * @memberof RemixNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof RemixNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof RemixNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof RemixNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<RemixNotificationAction>}
     * @memberof RemixNotification
     */
    actions: Array<RemixNotificationAction>;
}

/**
 * Check if a given object implements the RemixNotification interface.
 */
export function instanceOfRemixNotification(value: object): value is RemixNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function RemixNotificationFromJSON(json: any): RemixNotification {
    return RemixNotificationFromJSONTyped(json, false);
}

export function RemixNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemixNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(RemixNotificationActionFromJSON)),
    };
}

export function RemixNotificationToJSON(value?: RemixNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(RemixNotificationActionToJSON)),
    };
}

